import React from 'react';
import NavBar from './NavBar';

const Layout = ({ children, onLogout, user }) => {
  return (
    <div>
      <NavBar onLogout={onLogout} user={user} />
      <div className="container">
        {children}
      </div>
    </div>
  );
};

export default Layout; 